import React, { useState, useEffect, useContext } from 'react';
import LabeledInput from '../common/LabeledInput';
import { VendorContext } from '../providers/Vendor';
import { PersonContext } from '../providers/Person';
import requests from '../utils/requests';
import { s } from '../Style';

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const BusinessHours = ({ screen, setScreen }) => {
  const { auth } = useContext(PersonContext);
  const { vendor, refreshVendor } = useContext(VendorContext);

  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingVendor, setEditingVendor] = useState({});

  useEffect(() => {
    if (vendor) setEditingVendor(vendor);
  }, [vendor]);

  const getBusinessHourForDay = (day) =>
    (editingVendor?.businessHours || []).find((bh) => bh.day === day) || {};

  const updateBusinessHour = (day, key, value) => {
    const otherDays = (editingVendor.businessHours || []).filter((bh) => bh.day !== day);
    const existing = getBusinessHourForDay(day);

    const updatedDay = {
      day,
      open: key === 'open' ? value : existing.open || '',
      close: key === 'close' ? value : existing.close || '',
      pastMidnight: key === 'pastMidnight' ? value : existing.pastMidnight || false,
    };

    setEditingVendor({
      ...editingVendor,
      businessHours: [...otherDays, updatedDay],
    });
  };

  const renderDayRow = (day, index) => {
    const data = getBusinessHourForDay(day);
    return (
      <div style={s.cell(index % 2)} key={day}>
        <label style={{ width: 60, display: 'inline-block' }}>{day}</label>
        <LabeledInput
          label=""
          type="time"
          value={data.open || ''}
          onChange={(e) => updateBusinessHour(day, 'open', e)}
        />
        <LabeledInput
          label="To"
          type="time"
          value={data.close || ''}
          onChange={(e) => updateBusinessHour(day, 'close', e)}
        />
      </div>
    );
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      await requests.updateBusinessHours({
        auth,
        id: vendor.id,
        values: { businessHours: editingVendor.businessHours },
      });
      await refreshVendor();
    } catch (err) {
      console.error('Error saving business hours:', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {(saving || loading) && (
        <p>
          <i className="fas fa-spinner fa-spin"></i>
        </p>
      )}

      {!saving && !loading && (
        <>
          <h2>Business Hours</h2>

          <div style={s.box}>
            <div style={s.table}>{DAYS.map((day, i) => renderDayRow(day, i))}</div>

            <button onClick={handleSave}>Save</button>
          </div>
        </>
      )}
    </>
  );
};

export default BusinessHours;
